module.exports = __webpack_public_path__ + "e92c33bd41a09684279ba0850ffe4bf8.svg";